import type { ResponderQuestionInput } from './shared-responder-v2-project.types';

export function resolveHasAttributedContact(args: {
  readonly email: string | null;
  readonly isAnonymousProject: boolean | null | undefined;
}): boolean {
  return args.email !== null && args.isAnonymousProject !== true;
}

export function selectServedQuestions(
  questions: readonly ResponderQuestionInput[],
  args: { readonly hasAttributedContact: boolean }
): readonly ResponderQuestionInput[] {
  if (!args.hasAttributedContact) {
    return questions;
  }

  const firstServedQuestionId = questions.toSorted(
    (a, b) => a.questionOrder - b.questionOrder
  )[0]?.id;

  return questions.filter(
    (question) =>
      !question.isContactInfo || question.id === firstServedQuestionId
  );
}
